var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaEyeSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1792,
    height: 1376,
    viewBox: "0 0 1792 1376",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m555 1079l78-141q-87-63-136-159t-49-203q0-121 61-225q-229 117-381 353q167 258 427 375m389-759q0-20-14-34t-34-14q-125 0-214.5 89.5T592 576q0 20 14 34t34 14t34-14t14-34q0-86 61-147t147-61q20 0 34-14t14-34m363-191q0 7-1 9q-106 189-316 567t-315 566l-49 89q-10 16-28 16q-12 0-134-70q-16-10-16-28q0-12 44-87q-143-65-263.5-173T20 773Q0 742 0 704t20-69q153-235 380-371t496-136q89 0 180 17l54-97q10-16 28-16q5 0 18 6t31 15.5t33 18.5t31.5 18.5T1291 102q16 10 16 27m37 447q0 139-79 253.5T1056 994l280-502q8 45 8 84m448 128q0 35-20 69q-39 64-109 145q-150 172-347.5 267T896 1280l74-132q212-18 392.5-137T1664 704q-115-179-282-294l63-112q95 64 182.5 153T1772 635q20 34 20 69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaEyeSlash);
export default __webpack_public_path__ + "static/media/fa-eye-slash.7c00c8abe4c22a9befd054c6e24e6e3e.svg";
export { ForwardRef as ReactComponent };